// utils/surveyUtils.js
import api from "../api/Api";

/**
 * Default UI text values before language data is loaded
 */
export const defaultTexts = {
  welcome_string_text: "Welcome. Thank you for your participation in this survey.",
  transitionText: "You are now going to move on the next set of questions.",
  intermission_prompt_text: "Please take some time to rest.",
  consumption_prompt_explicit: "Please consume sample.",
  survey_end: "The survey is complete. Thank you for your participation.",
  begin_button: "Begin",
  continue_button: "Continue",
  input_user_id: "Please input the ID you were provided with.",
  kiosk_timeout_text: "Are you still there? Touch anywhere to continue.",
  next_button: "Next",
};

/**
 * Fetch survey and language data — equivalent to checkLogIn
 */
export const checkLogIn = async ({
  surveyId,
  setSampleMode,
  intermissionNumber,
  intermissionTime,
  vasAlert,
  translation,
  setIsInputDisabled,
  setErrorMessage,
  languagesRef,
}) => {
  try {
    const [data, lanData] = await Promise.all([
      api.fetchSurveyData(surveyId),
      api.fetchLanguages(surveyId),
    ]);

    languagesRef.current = lanData;

    if (data && data.survey_id == surveyId) {
      setSampleMode(data.sample_mode);
      intermissionNumber.current = data.intermission_number_aromas;
      intermissionTime.current = data.intermission_time;
      vasAlert(data.sample_mode); // call the component-provided handler
    }
  } catch (error) {
    console.error("checkLogIn failed →", error);
    setIsInputDisabled(false);
    setErrorMessage(translation("invalidIDMessage"));
  }
  console.log("Checking login for:", surveyId);
};

/**
 * Update translatable text fields from language config
 */
export const updateTexts = ({
  languagesRef,
  texts,
  welcomeText,
  implicitExplicitText,
  intermissionText,
  consumptionText,
  surveyEndText,
  beginButtonText,
  continueButtonText,
  inputUserIDText,
  kioskTimeoutText,
  nextButtonText,
}) => {
  languagesRef.current.forEach((element) => {
    if (element.string_id in texts) {
      texts[element.string_id] = element.string;
    }
  });

  welcomeText.current = texts.welcome_string_text;
  implicitExplicitText.current = texts.transitionText;
  intermissionText.current = texts.intermission_prompt_text;
  consumptionText.current = texts.consumption_prompt_explicit;
  surveyEndText.current = texts.survey_end;
  beginButtonText.current = texts.begin_button;
  continueButtonText.current = texts.continue_button;
  inputUserIDText.current = texts.input_user_id;
  kioskTimeoutText.current = texts.kiosk_timeout_text;
  nextButtonText.current = texts.next_button;
};